import {defineMessages} from 'react-intl';

export const videoReliefMessages = defineMessages({
    networkLead: {id: 'callSurface.relief.network-lead', defaultMessage: 'Weak connection — pause video?'},
    cpuLead: {id: 'callSurface.relief.cpu-lead', defaultMessage: 'Your device is overloaded — pause video?'},
    body: {id: 'callSurface.relief.body', defaultMessage: 'Audio keeps going.'},
    pause: {id: 'callSurface.relief.pause', defaultMessage: 'Pause video'},
    notNow: {id: 'callSurface.relief.not-now', defaultMessage: 'Not now'},
    recoveredLead: {id: 'callSurface.relief.recovered-lead', defaultMessage: 'Connection is back — resume video?'},
    resume: {id: 'callSurface.relief.resume', defaultMessage: 'Resume video'},
    paused: {id: 'callSurface.relief.paused', defaultMessage: 'Video paused · Tap to resume'},
});
